import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { useCallback, useState } from 'react'
import { ProfileEnterprises } from '../models'

const GET_PROFILE_ENTERPRISES = gql`
  query ProfileEnterprises($profileId: String!) {
    profile(id: $profileId) {
      id
      familyName
      enterprises {
        id
        name
        active
        domain
        subdomain
        products
        addresses {
          countryId
        }
        agencies {
          id
          name
          active
          type
          products {
            code
            name
            providerCode
          }
        }
      }
    }
  }
`

export interface ProfileEnterprisesQuery {
  profile: ProfileEnterprises
}

export const useProfileEnterprises = () => {
  const [getResults, { loading, error, data }] = useLazyQuery<ProfileEnterprisesQuery>(GET_PROFILE_ENTERPRISES, {
    fetchPolicy: 'network-only',
  })

  const getProfileEnterprises = useCallback(
    (profileId: string) => {
      getResults({
        variables: { profileId },
      })
    },
    [],
  )

  return { getProfileEnterprises, loading, error, data }
}
